import React, { createContext, useContext, useState } from "react"

type OrganizationCtx = {
    organizationId: string | null
    setOrganizationId: (id: string | null) => void
}

const OrganizationContext = createContext<OrganizationCtx | undefined>(undefined)


export const OrganizationProvider = ({
    children,
}: {
    children: React.ReactNode
}) => {
    const [organizationId, setOrganizationId] = useState<string | null>(() => {
        try {
            return sessionStorage.getItem("organizationId")
        } catch {
            return null
        }
    })

    const changeOrganization = (id: string | null) => {
        setOrganizationId(id)
        if (id)
            sessionStorage.setItem("organizationId", id)
        else
            sessionStorage.removeItem("organizationId")

    }

    return (
        <OrganizationContext.Provider
            value={{ organizationId, setOrganizationId: changeOrganization }}
        >
            {children}
        </OrganizationContext.Provider>
    )
}

export const useOrganization = () => {
    const ctx = useContext(OrganizationContext)
    if (!ctx) {
        throw new Error("useOrganization must be used within an OrganizationProvider")
    }
    return ctx
}
